import { createFileRoute } from "@tanstack/react-router";
import { CampaignBoardRoute } from "@/features/office";

export const Route = createFileRoute("/_office/unlisted/office/campaign-board")(
  {
    validateSearch: (search: Record<string, unknown>) => {
      const league = Array.isArray(search.league)
        ? search.league[0]
        : search.league;

      return { league: typeof league === "string" ? league : undefined };
    },
    head: () => ({ meta: [{ title: "Campaign board | Softmax" }] }),
    component: CampaignBoardPage,
  },
);

function CampaignBoardPage() {
  const { league } = Route.useSearch();

  return <CampaignBoardRoute leagueParam={league} />;
}
